import {Fragment} from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import Stack from '@mui/material/Stack'

import {MAXIMUM_CONTACTS, REQUIRED_CONTACTS} from '../../../lib/recovery'

const SLOTS = [...Array(MAXIMUM_CONTACTS).keys()]

// The one piece of teaching these screens do: five slots with a rule drawn after the third, so the
// difference between "enough people" and "enough to actually recover" is visible rather than stated.
const KeyShares = ({ready = 0, large = false}) => (
  <Stack
    className={classnames('key-shares', {large})}
    component='div'
    direction='row'
    role='img'
    aria-label={`${ready} of ${MAXIMUM_CONTACTS} pieces held, ${REQUIRED_CONTACTS} needed to recover`}>
    {
      SLOTS.map(slot => (
        <Fragment key={slot}>
          {slot === REQUIRED_CONTACTS && <span className='threshold' />}
          <span className={classnames('share', {held: slot < ready})} />
        </Fragment>
      ))
    }
  </Stack>
)

KeyShares.propTypes = {
  ready: PropTypes.number,
  large: PropTypes.bool
}

export default KeyShares
